/* Native contact submission stays untouched. This enhancement only adapts hints
   and optional fields; without JS the complete form remains available. */
(() => {
  const key = Symbol.for('k9.contact.interactions');
  if (window[key]) return;
  window[key] = true;
  const bound = new WeakSet();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    document.querySelectorAll('.k9-contact > form').forEach(form => {
      const subject = form.querySelector('[data-k9-contact-subject]');
      if (!subject || bound.has(form)) return;
      bound.add(form);
      const orderField = form.querySelector('[data-k9-order-field]');
      const order = orderField?.querySelector('input');
      const email = form.querySelector('[name="contact[email]"]');
      const emailHint = form.querySelector('#ContactForm-email-hint');
      const messageHint = form.querySelector('#ContactForm-body-hint');
      const affiliateHint = form.querySelector('[data-k9-affiliate-hint]');
      const defaultMessage = messageHint?.textContent;
      function update() {
        const isOrder = subject.value === 'commande';
        if (orderField) orderField.hidden = !isOrder;
        if (order) order.disabled = !isOrder;
        if (emailHint) emailHint.hidden = !isOrder;
        if (affiliateHint) affiliateHint.hidden = subject.value !== 'affiliation';
        if (messageHint) messageHint.textContent = messageHint.getAttribute(`data-hint-${subject.value}`) || defaultMessage;
        if (email) {
          const descriptions = new Set((email.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
          descriptions.delete('ContactForm-email-hint');
          if (isOrder && emailHint) descriptions.add('ContactForm-email-hint');
          if (descriptions.size) email.setAttribute('aria-describedby', [...descriptions].join(' '));
          else email.removeAttribute('aria-describedby');
        }
      }
      subject.addEventListener('change', update);
      form.addEventListener('reset', () => queueMicrotask(update));
      window.addEventListener('pageshow', update);
      const requested = new URL(location.href).searchParams.get('motif');
      if (!subject.value && [...subject.options].some(option => option.value === requested)) subject.value = requested;
      update();
      const main = form.closest('main');
      main?.querySelectorAll('[id$="__contact_help"] a[href]').forEach(link => {
        const url = new URL(link.href, location.href);
        const motif = url.searchParams.get('motif');
        if (url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#ContactForm-subject' || ![...subject.options].some(option => option.value === motif)) return;
        link.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          subject.value = motif;
          update();
          subject.focus({ preventScroll: true });
          subject.scrollIntoView({ block: 'center', behavior: reduced.matches ? 'auto' : 'smooth' });
        });
      });
    });
  }
  document.addEventListener('shopify:section:load', init);
  init();
})();
